import 'sanitize.css';
import 'sanitize.css/assets.css';
import 'sanitize.css/forms.css';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';

import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    /* We need to use stylistic sets with our fonts */
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
    font-family: var(--sans-serif-font);
  }

  body {
    overflow-y: hidden;
    height: 100%;
  }

  body:hover {
    overflow-y: overlay;
  }

  input {
    font-family: var(--sans-serif-font);
  }

  a {
    text-decoration: none;
  }

  html {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.bgPrimary};
  }

  #root {
    width: 100%;
    min-height: 100vh;
  }

  form {
    width: 100%;
  }

  /* Override styles of menu component */
  .szh-menu {
    border-radius: 0.5rem;
  }
`;
